import { createReducer, on } from '@ngrx/store';
import { createPasswordStoreData } from '../../core/models/Interfaces/createPassword';
import {
  resetPasswordFailed,
  resetPasswordReceived,
  resetPasswordRequest,
  resetPasswordState,
} from '../actions/createPasswordAction';

const initialState: createPasswordStoreData = {
  isFetchingPassword: false,
  passwordData: null,
  isResetPasswordSuccess: false,
  isResetPasswordFailed: false,
};

export const createPasswordReducer = createReducer(
  initialState,
  on(resetPasswordRequest, (state) => {
    return { ...state, isFetchingPassword: true };
  }),
  on(resetPasswordReceived, (state, { data }) => {
    return {
      ...state,
      isFetchingPassword: false,
      passwordData: data,
      isResetPasswordSuccess: true,
      isResetPasswordFailed: false,
    };
  }),
  on(resetPasswordFailed, (state) => {
    return {
      ...state,
      isFetchingPassword: false,
      passwordData: null,
      isResetPasswordFailed: true,
      isResetPasswordSuccess: false,
    };
  }),
  on(resetPasswordState, (state) => {
    return {
      ...state,
      isFetchingPassword: false,
      passwordData: null,
      isResetPasswordFailed: false,
      isResetPasswordSuccess: false,
    };
  }),
);
